
import VeeValidate from 'vee-validate'
import Rules from '@/config/validate/rules'
import VeeValidateI18nKo from '@/config/validate/i18n/ko'

const MmpVeeValidate = {
  install (Vue, options) {
    Object.keys(Rules).forEach(function (rule) {
      VeeValidate.Validator.extend(rule, Rules[rule])
    })

    Vue.use(VeeValidate, {
      locale: 'ko',
      dictionary: {
        ko: VeeValidateI18nKo
      }
    })
  }
}

export default MmpVeeValidate



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpVeeValidate.js